/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2024)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from "react"

import { ImageEditorType } from "@glideapps/glide-data-grid"
import styled from "@emotion/styled"

const StyledImage = styled.img({
  maxWidth: "100%",
  maxHeight: "37.5rem",
  objectFit: "scale-down",
})

export const ImageCellEditor: ImageEditorType = ({ urls }) => {
  const imageData = urls && urls.length > 0 ? urls[0] : ""
  // Allow external image links to be opened in a new tab on click
  if (imageData.startsWith("http")) {
    return (
      <a href={imageData} target="_blank" rel="noreferrer noopener">
        <StyledImage src={imageData}></StyledImage>
      </a>
    )
  }

  return <StyledImage src={imageData}></StyledImage>
}
